import React from 'react';

import LinkWithPrevLocation from '@common/react/components/UI/LinkWithPrevLocation/LinkWithPrevLocation';
import Loader from '@common/react/components/Core/LoadingProvider/Loader';

import ShoppingCartInformation from '@app/components/UI/ShoppingCartInformation/ShoppingCartInformation';

const ShoppingCart: React.FC = () => {
	const [init, setInit] = React.useState<boolean>(false);

	React.useEffect(() => {
		setInit(true);
	}, []);

	return <>
		{init
			? <div className="container">
				<ShoppingCartInformation
					checkout={
						<LinkWithPrevLocation to="/ordering" className="btn btn-primary check-out__btn">
							Check out
						</LinkWithPrevLocation>
					}
				/>
			</div> : <Loader />
		}
	</>;
};

export default ShoppingCart;
